import script from "./FunctionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FunctionMenu.vue?vue&type=script&setup=true&lang=js"

import "./FunctionMenu.vue?vue&type=style&index=0&id=2e9bc354&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9bc354"]])

export default __exports__